import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class LessonsService {
  url: string;
  headers: any;

  constructor(
    private http: HttpClient
  ) {
    this.url = environment.api_base_url;
    // TODO: SPRING missing Access-Control-Allow-Headers: contenttype in preflight
    this.headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
  }

  create(resource) {
    return this.http.post(this.url + '/lessons', resource, { headers: this.headers});
  }

  update(resource) {
    return this.http.post(this.url + '/lessons/', resource, { headers: this.headers});
  }

  delete(id) {
    return this.http.delete(this.url + '/lessons/' + id, { headers: this.headers});
  }
}
